<form [formGroup]="form" class="grid grid-cols-2 gap-4">
    <kendo-formfield class="col-span-1">
        <kendo-label text="{{'mittelabruf.date' | translate }} *" infotooltip="mittelabruf.date"
            [for]="mittelabrufDate"></kendo-label>
        <kendo-datepicker #mittelabrufDate appinfotext="mittelabruf.date" [disabled]="true" [value]="now"
            [incompleteDateValidation]="true">
        </kendo-datepicker>
    </kendo-formfield>
    <kendo-formfield>
        <kendo-label [text]="'mittelabruf.amount' | translate" infotooltip="mittelabruf.amount"
            [for]="amount"></kendo-label>
        <kendo-numerictextbox #amount [autoCorrect]="true" [min]="0" [format]="currencyFormatOptions"
            appinfotext="mittelabruf.amount" [spinners]="false" formControlName="amount"
            [disabled]="amountIsFixed"></kendo-numerictextbox>
    </kendo-formfield>
    <kendo-formfield *ngIf="showPaymentDate && payment?.paymentDate != null" class="col-span-1">
        <kendo-label text="{{'mittelabruf.paymentDate' | translate }} *" infotooltip="mittelabruf.paymentDate" [for]="paymentDate"></kendo-label>
        <kendo-datepicker #paymentDate appinfotext="mittelabruf.paymentDate" [disabled]="true"
            [value]="toDate(payment?.paymentDate ?? '')" [incompleteDateValidation]="true">
        </kendo-datepicker>
    </kendo-formfield>
</form>

<div *ngIf="getDocumentTypeName(dokumententyp)" class="d-flex align-items-center mt-8 mb-2">
    <h2 id="documentTypeName" class="form-label">
        {{ getDocumentTypeName(dokumententyp) }} {{ isUploadRequired() ? ' *' : '' }}
    </h2>
</div>
<p id="documentTypeInfo" class="form-subtitle mt-3" [trimRichtextTitle]="getDocumentTypeInfotext(dokumententyp)"
    [innerHTMLBypassXSS]="getDocumentTypeInfotext(dokumententyp)"></p>

<document-view *ngIf="dokumententyp != null" class="document-view mt-4" [formControl]="documentsForm"
    [paymentId]="payment?.id ?? ''" [documentType]="dokumententyp" (documentUpload)="onDocumentUpload($event)"
    (documentDelete)="onDocumentDelete($event)" [attr.aria-labelledby]="'documentTypeName'" [attr.aria-describedby]="'documentTypeInfo'"></document-view>

<kendo-dialog-actions>
    <button kendoButton class="xfound-button-secondary" (click)="onCancelClick()">{{ 'dialogue.buttons.cancel' |
        translate }}</button>
    <button kendoButton [disabled]="canSubmit == false" class="xfound-button-primary" (click)="onSubmitClick()">{{
        'dialogue.buttons.submit' | translate }}</button>
</kendo-dialog-actions>